export const AUTHORITIES = [
    'ROLE_USER',
    'ROLE_ORG_USER',
    'ROLE_ORG_MANAGER',
    'ROLE_ORG_ADMIN',
    'ROLE_ADMIN'
];
